// extracted by mini-css-extract-plugin
module.exports = {"badgeWrapper":"ReserveNowBadge_badgeWrapper__ZouPr","badge":"ReserveNowBadge_badge__8W84c","hasMobileString":"ReserveNowBadge_hasMobileString__zoBu2"};